import Modal from "../../common/Modal";
import ConveyorSelectionForm from "./ConveyorSelectionForm";

const AskCopyFromOthersModal = ({ visible, onSelect, onConfirm,  onCancel, conveyors }) => {

    return (
        <Modal visible={visible} title="Select Conveyor" confirmText="확인" cancelText="취소" onConfirm={onConfirm} onCancel={onCancel} description="복사하여 사용할 컨베이어를 선택하세요">
            <ConveyorSelectionForm onSelect={onSelect} conveyors={conveyors} />
        </Modal>
    );
};

export default AskCopyFromOthersModal;